export const readOnlyLabelTableText = '* The read-only data in this table is sourced from Yum Admin';